/* src/app/private/components/contact/create-contact/create-contact.component.scss */
label {
  font-weight: 500;
  margin-bottom: 5px;
}
.requiredValue::after {
  content: "*";
  color: red;
}
:host ::ng-deep .p-dialog .p-dialog-header {
  background-color: var(--surface-50);
  border-bottom: 1px solid var(--surface-200);
}
:host ::ng-deep .p-dialog .ng-invalid.ng-dirty {
  border-color: var(--red-500);
}
:host ::ng-deep h5 {
  color: var(--primary-color);
  font-weight: 600;
  margin-top: 0;
}
/*# sourceMappingURL=create-contact.component.css.map */
